<template>
	<div>
		{{ $t("pages.pageNotFound.title") }}
	</div>
</template>

<script>
export default {
  name: "PageNotFound",
};
</script>

<style scoped></style>
